import React, { useEffect } from 'react';
import Footer from '../components/Footer';

import cat1 from '../images/A.S FLUTE-01.png';
import cat2 from '../images/A.S FLUTE-02.png';
import cat3 from '../images/A.S FLUTE-03.png';
import cat4 from '../images/A.S FLUTE-04.png';

import cat5 from '../images/A.S LOUVERS-01.png';
import cat6 from '../images/A.S LOUVERS-02.png';
import cat7 from '../images/A.S LOUVERS-03.png';
import cat8 from '../images/A.S LOUVERS-04.png';

import Aslovurs from '../images/A.S LOUVERS.pdf';
import Asflute from '../images/A.S FLUTE.pdf';
import Pvcpanel from '../images/PvcPanel.pdf';
import Universal from '../images/Universal.pdf';
import Venion from '../images/VENION.pdf';

const Category = () => {
      useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
    
    return (
        <>


          <div className='headings'>
                <h3>OUR CATEGORY</h3>
            </div>
            <div className='productcatogorey'>

               

                <div className='product2'>

                    <div className='product3'>
                        <img src={cat1} />
                    </div>

                    <div className='product3'>
                        <img src={cat2} />
                    </div>

                    <div className='product3'>
                        <img src={cat3} />
                    </div>

                    <div className='product3'>
                        <img src={cat4} />
                    </div>

                </div>
                <div className='product2'>

                    <div className='product3'>
                        <img src={cat5} />
                    </div>

                    <div className='product3'>
                        <img src={cat6} />
                    </div>

                    <div className='product3'>
                        <img src={cat7} />
                    </div>

                    <div className='product3'>
                        <img src={cat8} />
                    </div>

                </div>




                <h2 className="text-center text-white mt-4">View More Details  in PDF</h2>

                <div className="d-flex justify-content-center gap-3 flex-wrap mt-4">
                    <a
                        href={Aslovurs}
                        download="A.S_LOUVERS.pdf"
                        className="btn btn-success"
                        aria-label="Download A.S LOUVERS PDF"
                    >
                        A.S LOUVERS PDF Download
                    </a>
                    <a
                        href={Asflute}
                        download="A.S_FLUTE.pdf"
                        className="btn btn-success"
                        aria-label="Download A.S FLUTE PDF"
                    >
                        A.S FLUTE PDF Download
                    </a>
                    <a
                        href={Pvcpanel}
                        download="PvcPanel.pdf"
                        className="btn btn-success"
                        aria-label="Download P.V.C. Panel PDF"
                    >
                        P.V.C. Panel PDF Download
                    </a>
                    <a
                        href={Universal}
                        download="Universal_UV_Marble.pdf"
                        className="btn btn-success"
                        aria-label="Download Universal UV Marble PDF"
                    >
                        Universal UV Marble PDF Download
                    </a>
                    <a
                        href={Venion}
                        download="Venion.pdf"
                        className="btn btn-success"
                        aria-label="Download Venion PDF"
                    >
                        Venion PDF Download
                    </a>
                </div>

                <br />
            </div>
            <Footer />
        </>
    );
};

export default Category;